import { LoanappService } from './../../services/loanapp.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AngularCsv } from 'angular7-csv/dist/Angular-csv';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { AuthService } from 'app/services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-cma-appointments',
  templateUrl: './cma-appointments.component.html',
  styleUrls: ['./cma-appointments.component.css'],
})
export class CmaAppointmentsComponent implements OnInit {
  user: any;
  p: number = 1;
  itemsPerPage = 10;
  currentPage = 1;
  lApplications: Array<any> = [];
  dataRec: Boolean = false;
  dataToShow: Array<any> = [];
  appObj: any;
  filterWnameArr: Array<string> = [];
  loanAppsLoaded: Boolean = false;

  constructor(
    private lservice: LoanappService,
    private router: Router,
    private auth: AuthService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.getProfile();
    this.loanAppsLoaded = false;

    this.lservice.getCmaAppointedApplications().subscribe((data) => {
      this.loanAppsLoaded = true;

      this.dataRec = true;
      if (data['success']) {
        this.lApplications = data['data'];
        this.dataToShow = data['data'];
        for (let i = 0; i < this.dataToShow.length; i++) {
          this.dataToShow[i]['tprice'] =
            this.dataToShow[i]['depositApp']['depositQty'] *
            this.dataToShow[i]['depositApp']['perUnitValue'];
          if (
            !this.isInArray(
              this.lApplications[i]['warehouseName'],
              this.filterWnameArr
            )
          ) {
            this.filterWnameArr.push(this.lApplications[i]['warehouseName']);
          }
        }
      }
    });
  }
  getProfile() {
    this.loanAppsLoaded = false;

    this.auth.getProfile().subscribe(
      (profile) => {
        this.loanAppsLoaded = true;

        console.log(profile);
        this.user = profile['user'];
        if (this.user['profileCompleted'] == 'false') {
          this.router.navigateByUrl('/completeprofile');
        } else {
          if (this.user['accountStatus'] == 'inactive') {
            this.router.navigateByUrl('/completeprofile');
          } else {
            console.log('All done');
          }
        }
        //To check if toast in working fine on success of API

        // this.toastr.success("Working fine!");
      },
      (err) => {
        this.router.navigateByUrl('/login');
        console.log(err);
        this.toastr.error('Something went wrong, please try again');
        this.loanAppsLoaded = true;

        return false;
      }
    );
  }

  isInArray(value, array) {
    return array.indexOf(value) > -1;
  }

  downloadPDF() {
    var doc = new jsPDF('landscape');
    var col = [
      'Application ID',
      'Timestamp',
      'UserID',
      'Name',
      'Warehouse Name',
      ' Warehouse Id',
      'Commodity',
      'Quantity',
      'Grade',
      'Amount',
      'Application Status',
    ];
    var rows = [];

    this.dataToShow.forEach((element) => {
      let date = '';
      date = this.getDate(element.timestamp);
      var temp = [
        element._id,
        date,
        element.user.uniqueCode,
        element.applicantName,
        element.warehouseName,
        element.wId,
        element.commodityName,
        `${element.depositQty} ${element.depositUom}`,
        element.commodityGrade,
        element.totalReceiptValue,
        element.applicationStatus,
      ];
      rows.push(temp);
    });
    doc.setFontSize(9);
    doc.autoTable(col, rows);
    doc.save('CMA_Applications' + new Date().toDateString() + '.pdf');
  }

  getDate(d) {
    let f = new Date(d);
    let dateString = f.toString().slice(0, 15);
    return dateString;
  }

  print(cmpName) {
    let printContents = document.getElementById(cmpName).innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    location.reload();
  }

  downloadCSV() {
    let downArr = [];
    let attObj2s = {};
    for (let o = 0; o < this.dataToShow.length; o++) {
      attObj2s = {};
      attObj2s = {
        AppID: this.dataToShow[o]._id,
        Date: this.getDate(this.dataToShow[o].timestamp),
        ApplicationType: this.dataToShow[o].applicationType,
        ApplicantName: this.dataToShow[o].applicantName,
        WarehouseName: this.dataToShow[o].warehouseName,
        WId: this.dataToShow[o].wId,
        BankName: this.dataToShow[o].bname,
        BankId: this.dataToShow[o].bId,
        CommodityName: this.dataToShow[o].commodityName,
        TotalReceiptValue: this.dataToShow[o].totalReceiptValue,
        Quantity: `${this.dataToShow[o].depositQty} ${this.dataToShow[o].depositUom}`,
        Grade: this.dataToShow[o].commodityGrade,
        WarehouseNumber: this.dataToShow[o].warehouseNumber,
        BlockchainReceipId: this.dataToShow[o].blockchainReceiptId,
        CmaAppointmentstatus: this.dataToShow[o].cmaAppointmentstatus,
        CmaId: this.dataToShow[o].cmaId,
        NotificationSentToCMA: this.dataToShow[o].notificationSentToCMA,
        ApplicationStatus: this.dataToShow[o].applicationStatus,
        UserUniqueCode: this.dataToShow[o].user.uniqueCode,
        Address:
          this.dataToShow[o].address.addressL1 +
          ' ' +
          this.dataToShow[o].address.addressL2 +
          ' ' +
          this.dataToShow[o].address.village +
          ' ' +
          this.dataToShow[o].address.district +
          ' ' +
          this.dataToShow[o].address.state +
          ' ' +
          this.dataToShow[o].address.pincode,
      };

      if (this.dataToShow[o]['audit']) {
        attObj2s['AuditResult'] = this.dataToShow[o]['audit']['auditResult'];
        attObj2s['AuditStatus'] = this.dataToShow[o]['audit']['cas'];
        attObj2s['AuditCompanyname'] = this.dataToShow[o]['audit']['cCname'];
        attObj2s['AuditOfficerName'] = this.dataToShow[o]['audit']['cOname'];
        attObj2s['AuditDateTime'] = this.dataToShow[o]['audit']['datetime'];
      }
      if (this.dataToShow[o]['cmaDetails']) {
        attObj2s['CMAgrainName'] = this.dataToShow[o]['cmaDetails'][
          'CMAgrainName'
        ];
        attObj2s['CMAquantity'] = this.dataToShow[o]['cmaDetails'][
          'CMAquantity'
        ];
        attObj2s['CMAgrade'] = this.dataToShow[o]['cmaDetails']['CMAgrade'];
        attObj2s['CMAtotalMarketValue'] = this.dataToShow[o]['cmaDetails'][
          'CMAtotalMarketValue'
        ];
        attObj2s['CMAperUnitValue'] = this.dataToShow[o]['cmaDetails'][
          'CMAperUnitValue'
        ];
        attObj2s['CMAnoOfBags'] = this.dataToShow[o]['cmaDetails'][
          'CMAnoOfBags'
        ];
        attObj2s['CMAremark'] = this.dataToShow[o]['cmaDetails']['remark'];
      }
      if (this.dataToShow[o]['approved']) {
        attObj2s['LoanAmount'] = this.dataToShow[o]['approved']['loanAmount'];
        attObj2s['ProcessingFee'] = this.dataToShow[o]['approved'][
          'processingFee'
        ];
        attObj2s['RateOfInt'] = this.dataToShow[o]['approved']['rateOfInt'];
        attObj2s['LoanTenor'] = this.dataToShow[o]['approved']['loanTenor'];
        attObj2s['EmiAmount'] = this.dataToShow[o]['approved']['emiAmount'];
        attObj2s['RepaymentSchedule'] = this.dataToShow[o]['approved'][
          'repaymentSchedule'
        ];
        attObj2s['Timestamp'] = this.dataToShow[o]['approved']['timestamp'];
      }
      downArr.push(attObj2s);
    }

    setTimeout(() => {
      var options = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalseparator: '.',
        showLabels: false,
        headers: Object.keys(attObj2s),
        showTitle: false,
        title: 'name',
        useBom: false,
        removeNewLines: true,
        noDownload: false,
      };
      new AngularCsv(
        downArr,
        'CMA_Applications-' + new Date().toDateString(),
        options
      );
    }, 1000);
  }

  rowclick(value) {
    this.appObj = value;
    window.location.href =
      '/loanapplicationdetails?id=' +
      value['_id'] +
      '&p=cma' +
      '&uId=' +
      value['user']['_id'] +
      '&ref=cmaappointments';
  }

  onSearchChange(searchValue: string) {
    if (searchValue !== '') {
      this.dataToShow = this.filterItems(searchValue);
    } else {
      this.dataToShow = this.lApplications;
    }
  }

  filterItems(searchTerm) {
    return this.lApplications.filter((item) =>
      Object.keys(item).some(
        (k) =>
          item[k] != null &&
          item[k].toString().toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }

  onChangeWname(wname) {
    if (wname !== '') {
      this.dataToShow = this.filterWname(wname);
    } else {
      this.dataToShow = this.lApplications;
    }
  }
  filterWname(searchTerm) {
    let bArr = [];
    for (let u = 0; u < this.lApplications.length; u++) {
      if (
        this.lApplications[u].warehouseName.toLowerCase() ==
        searchTerm.toLowerCase()
      ) {
        bArr.push(this.lApplications[u]);
      }
    }
    return bArr;
  }

  onChangeStatus(status) {
    if (status !== '') {
      this.dataToShow = this.filterStatus(status);
    } else {
      this.dataToShow = this.lApplications;
    }
  }
  filterStatus(searchTerm) {
    let bArr = [];
    for (let u = 0; u < this.lApplications.length; u++) {
      if (
        this.lApplications[u].applicationStatus.toLowerCase() ==
        searchTerm.toLowerCase()
      ) {
        bArr.push(this.lApplications[u]);
      }
    }
    return bArr;
  }
  logout() {
    localStorage.clear();
    this.router.navigateByUrl('/login');
  }
}
